<template>
  <el-drawer
    title="写笔记"
    :visible.sync="drawerNoteVisible"
    direction="btt"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    @close="cancelSubmitNote(noteDrawerType)"
  >
    <div class="drawerMain-box writeNote-box">
      <p class="tips">引用内容：</p>
      <p class="quote-txt ellipsis-2"><span class="ellipsis-2">{{ selectedText }}</span></p>
      <textarea
        class="writeNote-textarea"
        placeholder="请输入您的笔记内容"
        v-model="textareaContent"
        @change="changeNoteTextarea"
      ></textarea>
      <div class="btn-box">
        <button type="submit" class="btn" @click="submitNote(noteDrawerType)">
          提交
        </button>
        <button
          type="button"
          class="btn cancel-btn"
          @click="cancelSubmitNote(noteDrawerType)"
        >
          取消
        </button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
  export default {
    name: "noteDrawer",
    props: {
      randomValue: {
        type: String,
        default: '',
      },
      //drawer 是否展示
      drawerNoteVisible: {
        type: Boolean,
        default: false,
      },
      selectedText: {
        type: String,
        default: '',
      },
      noteTextareaContent: {
        type: String,
        default: '',
      },
      noteDrawerType: {
        type: String,
        default: 'add',
      },
    },
    data() {
      return {
        textareaContent: ''
      }
    },
    watch: {
      noteTextareaContent() {
        this.textareaContent = this.noteTextareaContent
      }
    },
    methods: {
      changeNoteTextarea() {
        this.$emit('changeNoteTextarea', this.textareaContent)
      },
      // 点击记笔记中的提交，追加笔记列表
      submitNote(type) {
        if (this.noteTextareaContent == "") {
          this.$message({
            message: "请填写内容后再提交",
            type: "error",
            duration: 2000,
            customClass: "myMessageTip", // 自定义类名
          });
        } else {
          this.$emit('submitNote', type)
        }
      },
      // 取消写笔记
      cancelSubmitNote(type) {
        this.$emit('cancelSubmitNote', type)
      },
    }
  }
</script>

<style scoped lang="scss">
/deep/.el-drawer {
  width: 750px;
  height: 600px !important;
  min-height: 400px !important;
  margin: 0 auto !important;
  border-radius: 10px 10px 0 0;
  .el-drawer__header {
    height: 70px;
    margin-bottom: 0;
    border-bottom: 2px solid #E3E3E3;
    padding: 20px 30px 10px;
    color: #DDDDDD;
    text-align: left;
    span {
      font-size: 20px;
      font-weight: bold;
      color: #333;
    }
  }
  .el-drawer__body {
    padding: 20px 30px;
  }
}
/* 弹窗样式 start */
.drawerMain-box {
  text-align: left;
  height: 100%;
  overflow: auto;
  .block-label {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .tips {
    font-size: 14px;
    margin-bottom: 8px;
  }
  .quote-txt {
    margin-bottom: 20px;
    padding: 16px;
    height: auto;
    max-height: 78px;
    font-size: 16px;
    line-height: 28px;
    background: #F7F7F7;
    border-radius: 6px;
  }
  /deep/.quote-txt.quote-txt-2 {
    padding: 10px 16px;
    background: #f1f1f1;
    border: 1px dashed #4f678e;
    border-radius: 2px;
    max-height: 54px;
    font-size: 14px;
    margin-bottom: 10px;
  }
  /deep/.upload-img-box {
    display: flex;
    align-items: flex-start;
    > .el-upload-list__item {
      margin: 0 8px 8px 0;
      width: 80px;
      height: 80px;
      border-radius: 6px;
      overflow: hidden;
      border: 1px solid #c0ccda;
      display: flex;
      img {
        width: 100%;
      }
    }
  }
  .writeNote-textarea {
    padding: 10px;
    margin-bottom: 20px;
    width: 100%;
    min-height: 100px;
    height: 260px;
    font-size: 16px;
    font-family: unset;
    color: #333;
    border-radius: 6px;
    line-height: 28px;
    border: 1px solid #c1c1c1;
    -moz-user-select: auto !important; /*火狐*/
    -webkit-user-select: auto !important; /*webkit浏览器*/
    -ms-user-select: auto !important; /*IE10*/
    -khtml-user-select: auto !important; /*早期浏览器*/
    user-select: auto !important;
    list-style: auto !important;
    outline: none;
  }
  .writeNote-textarea:focus {
    border: 1px solid #0FC29A;
    outline: none;
  }
  .btn-box {
    width: 100%;
    /*text-align: center;*/
    .btn {
      width: 200px;
      margin: 0 auto;
      border: none;
      height: 40px;
      font-size: 16px;
      color: #f9f9f9;
      text-align: center;
      line-height: 40px;
      background: #0FC29A;
      border-radius: 4px;
      cursor: pointer;
    }
    .btn:hover {
      opacity: 0.9;
      color: #fff;
    }
    .btn.cancel-btn {
      margin-left: 20px;
      width: 120px;
      background: #B1B1B1;
    }
  }
}
/* 记笔记弹窗样式 end */
</style>